import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectRequiredToLogin } from '@us/web/shop/data-access';
import { selectIsLoggedIn } from '../+state/auth.reducer';

export const checkRequireLoginGuard = async () => {
    const router = inject(Router);
    const store = inject(Store);
    const requiredToLogin = store.selectSignal(selectRequiredToLogin);
    const isLoggedIn = store.selectSignal(selectIsLoggedIn);
    if (requiredToLogin() && !isLoggedIn()) {
        await router.navigateByUrl('/login');
        return false;
    }
    return true;
};
